import { LogCard } from './shared';
import type { LogCardAccordionItemClasses } from './shared/accordionStyles';
import { AgentInitConfig, formatConfigKey } from '../utils/logParser';

import i18n from '~/common/helpers/i18n';

interface ConfigurationCardProps {
  config: AgentInitConfig;
  isExpanded?: boolean;
  onExpandedChange?: (expanded: boolean) => void;
  itemKey?: string;
  itemClasses?: LogCardAccordionItemClasses;
  className?: string;
}

/**
 * Formats a configuration value for display
 */
const formatConfigValue = (value: string | undefined): string => {
  if (!value) return '-';
  return value;
};

/**
 * Component to display agent.init configuration in a structured, collapsible card
 */
export function ConfigurationCard({
  config,
  isExpanded,
  onExpandedChange,
  itemKey,
  itemClasses,
  className
}: ConfigurationCardProps) {
  const configEntries = Object.entries(config).filter(
    ([, value]) => value !== undefined && value !== null
  );

  if (configEntries.length === 0) {
    return null;
  }

  const title = (
    <span className='text-sm font-semibold text-on-surface'>
      {i18n.t('scenes.build.execution.logs.configuration.label') as string}
    </span>
  );

  return (
    <LogCard
      title={title}
      textValue={
        i18n.t('scenes.build.execution.logs.configuration.label') as string
      }
      isExpanded={isExpanded}
      onExpandedChange={onExpandedChange}
      itemKey={itemKey}
      itemClasses={itemClasses}
      className={className}
    >
      <div className='grid grid-cols-1 gap-3 sm:grid-cols-2'>
        {configEntries.map(([key, value]) => (
          <div key={key} className='flex flex-col gap-1'>
            <span className='text-xs font-medium text-on-surface-variant'>
              {formatConfigKey(key)}
            </span>
            <span className='text-sm text-on-surface'>
              {formatConfigValue(value)}
            </span>
          </div>
        ))}
      </div>
    </LogCard>
  );
}
